<template>
  <v-app>
    <RouterView />

    <!-- register base components here -->
    <VLibraComponent />
    <BaseLoading />
    <BaseSnackBar />

    <!-- <WhatsAppButton v-if="hasWhatsAppSupportUrl" /> -->
  </v-app>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue'
import BaseLoading from './components/base/BaseLoading.vue'
import BaseSnackBar from './components/base/BaseSnackBar.vue'
import { useConnectionStatusStore } from './stores/connection'
import VLibraComponent from '@/components/vlibras/VLibraComponent.vue'
import { getActiveOrganizationData } from './services/organization.service'
import { useRoleStore } from './stores/role'
// import WhatsAppButton from './components/icons/WhatsAppButton.vue'

const connectionStore = useConnectionStatusStore()
const roleStore = useRoleStore()

window.addEventListener('offline', () => connectionStore.setOffline())
window.addEventListener('online', () => connectionStore.setOnline())

// const hasWhatsAppSupportUrl = computed(() => import.meta.env.VITE_WHATSAPP_SUPPORT_URL?.length > 0)

onMounted(async () => {
  const organization = await getActiveOrganizationData()

  if (organization.custom_roles_name) {
    roleStore.setCustomRolesName(organization.custom_roles_name)
  }
})
</script>
